<template>
  <div class="Login">

    <el-container class="LoginBox">
      <el-header class="LoginBox-header">
        <img
            alt=""
            src="@/assets/login_logo.png"
            srcset="@/assets/login_logo@2x.png 2x"
        />
      </el-header>

      <el-main class="LoginBox-main">
        <h1>{{ $t("changePassword.title") }}</h1>
        <p>
          {{ $t("changePassword.titleDescription") }}
        </p>
        <el-form
            ref="formForm"
            label-position="top"
            v-loading.fullscreen.lock="loading"
            :element-loading-text="$t('portals.list.chargementDonnees')"
            :model="form"
            :rules="formFormRules"
            @submit-valid="submit"
            @submit-error="onError"
        >
          <el-form-item prop="password">
            <template slot="label">{{ $t("changePassword.password1") }}</template>
            <el-input :type="typePassword" v-model="form.password" :placeholder="$t('changePassword.password1Placeholder')">
              <div slot="append"><img @click="handlePassword" :src="require(`@/assets/${eyeFilename}`)" width="20"></div>
            </el-input>
          </el-form-item>
          <el-form-item prop="confirmPassword">
            <template slot="label">{{ $t("changePassword.password2") }}</template>
            <el-input :type="typeConfirmPassword" v-model="form.confirmPassword" :placeholder="$t('changePassword.password2Placeholder')">
              <div slot="append"><img @click="handleConfirmPassword" :src="require(`@/assets/${eyeFilenameConfirm}`)" width="20"></div>
            </el-input>
          </el-form-item>
          <!--<div v-if="error">{{ error }}</div>-->
          <el-button
              class="Login-formSubmit w-100"
              native-type="submit"
              type="danger"
          >{{ $t("changePassword.confirm") }}
          </el-button
          >
        </el-form>
      </el-main>

      <el-footer class="LoginBox-footer" height="auto">
        <h3>{{ $t("changePassword.backToLogin") }}</h3>
        <router-link to="login" class="LoginBox-reinitPassword">
          <el-link>{{ $t("changePassword.backToLoginLink") }}</el-link>
        </router-link>
      </el-footer>
    </el-container>

    <div class="Login-slogan" v-if="browserContext.up('xl')">
      <img
          alt=""
          :src="require(`@/assets/${loginSlogan}.png`)"
          :srcset="require(`@/assets/${loginSlogan}@2x.png`) + ' 2x'"
      />
    </div>

    <languages></languages>

    <div class="Login-footer">
      <a :href="websiteUrl" target="_blank" rel="noopener">{{ $t("general.ubiflowWebsite") }}</a>
    </div>
  </div>
</template>

<script>
import { tryAuthenticateWithToken, updateUserPasswordFromToken } from '@/services/auth'
import { Divider } from 'element-ui'
import i18next from 'i18next'
import Languages from '../components/Languages'

export default {
  name: 'Login',
  components: { Languages, ElDivider: Divider },
  inject: ['browserContext'],
  metaInfo () {
    return {
      title: this.$t('changePassword.metaTitle'),
      htmlAttrs: {
        class: 'Root--login'
      }
    }
  },
  data () {
    const checkConfirmPassword = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('validator.passwordConfirmationRequired')))
      }
      setTimeout(() => {
        if (value !== this.form.password) {
          callback(new Error(this.$t('validator.passwordMustBeEquals')))
        } else {
          callback()
        }
      }, 1000)
    }
    return {
      response: {},
      loading: false,
      error: null,
      form: { password: null, confirmPassword: null },
      formFormRules: {
        password: [
          { required: true, trigger: 'blur', message: this.$t('validator.passwordRequired') }
        ],
        confirmPassword: [
          { required: true, trigger: 'blur', validator: checkConfirmPassword }
        ]
      },
      showPassword: false,
      showConfirmPassword: false,
      eyeFilename: 'icon-eye.png',
      eyeFilenameConfirm: 'icon-eye.png',
      typePassword: 'password',
      typeConfirmPassword: 'password'
    }
  },
  methods: {
    onError (error) {
      this.error = error
    },
    handlePassword () {
      this.showPassword = !this.showPassword
      if (this.showPassword) {
        this.eyeFilename = 'icon-eye-hide.png'
        this.typePassword = 'text'
      } else {
        this.eyeFilename = 'icon-eye.png'
        this.typePassword = 'password'
      }
    },
    handleConfirmPassword () {
      this.showConfirmPassword = !this.showConfirmPassword
      if (this.showConfirmPassword) {
        this.eyeFilenameConfirm = 'icon-eye-hide.png'
        this.typeConfirmPassword = 'text'
      } else {
        this.eyeFilenameConfirm = 'icon-eye.png'
        this.typeConfirmPassword = 'password'
      }
    },
    async submit () {
      this.loading = true
      this.error = null
      try {
        const token = this.$route.query.token
        let result = await updateUserPasswordFromToken(token, this.form.password)
        if (result.type == 'error') {
          // this.$message({message: this.$t("error.found"), type: 'error'});
          this.loading = false
          return false
        }
        this.response = result
        if (!result) {
          return false
        }

        result = await tryAuthenticateWithToken(token)
        if (result.type == 'error') {
          // this.$message({message: this.$t("error.found"), type: 'error'});
          this.loading = false
          return false
        }
        this.response = result
        if (!result) { return (this.error = this.$t('error.unknown')) }
        this.$router.push(
          (this.$route.params && this.$route.params.redirect) || {
            name: 'dashboard'
          }
        )
      } catch (err) {
        this.error = this.$t(err.message)
      } finally {
        this.loading = false
      }
    }
  },
  computed: {
    websiteUrl () {
      return processEnvConfig.VUE_APP_UBIFLOW_WEBSITE_URL
    },
    loginSlogan () {
      if (i18next.language === 'mx') {
        return 'login_slogan_es'
      }
      return 'login_slogan_' + i18next.language
    }
  }
}
</script>

<style lang="scss">
	@import "@/theme/_bootstrap.scss";

	html.Root--login {
		&,
		body {
			height: 100%;
		}
		body {
			align-items: center;
			background: url("~@/assets/login_background.jpg");
			@include image-retina("~@/assets/login_background.jpg", 2880, 1620);
			background-position: center center;
			background-size: cover !important;
			background-attachment: fixed;
			background-repeat: no-repeat;
			display: flex;
			flex: 1;
			justify-content: center;
			padding: 0;
			@media screen and (max-height: 760px) {
				align-items: flex-start;
			}
		}
	}

	.Login {
		flex: 1;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;

		.LoginBox {
			@extend .card, .mx-4, .mb-5;
			max-width: 420px;
			margin-top: map-get($spacers, 5) * 2 !important;
			@media screen and (max-height: 760px) {
				margin-top: 60px + map-get($spacers, 5) * 2 !important;
			}

			h1 {
				border-bottom: 1px solid $blue;
				@include media-breakpoint-down(xs) {
					// Cannot use @extend in media
					padding-bottom: map-get($spacers, 4) !important; // pb-4
				}
			}

			&-header {
				position: absolute;
				text-align: center;
				transform: translateY(-100%);
				top: map-get($spacers, 5) * -1;
				width: 100%;
				height: 60px;

				img {
					max-width: 100%;
				}
			}

			&-main {
				@extend .card-body;
			}
			&-footer {
				background: $yellow-pastel;
				@extend .card-footer;
			}
			&-reinitPassword {
				font-size: $font-size-sm-alt;
			}
		}

		&-slogan {
			@extend .font-secondary;
			color: $white;
			font-size: $font-size-base * 2;
			font-weight: lighter;
			line-height: $font-size-base * 2.5;
			position: absolute;
			right: 20%;
			text-align: center;
			top: 50%;
			transform: translate(50%, -50%);
			width: 200px;

			.fifteen {
				@extend .text-warning;
				font-size: $font-size-base * 5;
				line-height: $font-size-base * 4.5;
				display: block;
			}
			.simplify {
				@extend .text-primary;
				display: block;
			}
		}

		&-footer {
			@extend .px-4, .py-3, .text-right;
			font-size: $font-size-sm;
			background: rgba(22, 64, 77, 0.8);
			bottom: 0;
			font-weight: lighter;
			left: 0;
			position: fixed;
			right: 0;

			@media screen and (max-height: 760px) {
				position: static;
				width: 100%;
			}

			a {
				color: $white;
			}
		}
	}
</style>
